module.exports = __webpack_public_path__ + "img/trophy-fill.4451efa6.svg";